const ethNetworkIds = {
  testnet: 11155111,
  mainnet: 1,
}

const bnbNetworkIds = {
  testnet: 97,
  mainnet: 56,
}

const polygonNetworkIds = {
  testnet: 80001,
  mainnet: 137,
}

export type evmNetworkIdsType = {
  BNB: any
  ETHEREUM: any
  POLYGON: any
  MULTIVERSX: any
}

export const evmNetworkIds: evmNetworkIdsType = {
  BNB: bnbNetworkIds,
  ETHEREUM: ethNetworkIds,
  POLYGON: polygonNetworkIds,
  MULTIVERSX: { testnet: null, mainnet: null },
}

export type evmIdsType = {
  bnb: any
  ethereum: any
  polygon: any
  multiversx: any
}

export const evmIds: evmIdsType = {
  bnb: bnbNetworkIds,
  ethereum: ethNetworkIds,
  polygon: polygonNetworkIds,
  multiversx: { testnet: null, mainnet: null },
}
